module.exports = __webpack_public_path__ + "static/media/search-grey-icon.ee1802c6.svg";